import type { FaireProductEntity } from "../../entity_types/product";

export const p_d7ynwmtw: FaireProductEntity = {
  token: "p_d7ynwmtw",
  type: "product",
  name: "Baby Moccasins - Genuine Leather Baby Shoes (Classic Brown)",
  brandToken: "b_5ytgyrzl",
  brandName: "BirdRock Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/a94866668cdc1705cadd3d2c9e4f78429cca2a533e462a6a672413ba03d44b9c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13bbf64558329899441121885097cdd837766a0bbc993a6ad894f8c942196ef1.jpeg",
    "https://cdn.faire.com/fastly/fc0b3d65624b09cff2f34eb49af9ea0404dd0c5931d0f1704540a065d9875ac5.jpeg",
    "https://cdn.faire.com/fastly/d0efc9b0fdb24e0daf1982167b1b411392c789f490b744be6b9186986ff6add7.jpeg",
    "https://cdn.faire.com/fastly/8997c89cc91969ee5c8a601971cab12b504b9e85d34ac047f207843e63788656.jpeg",
    "https://cdn.faire.com/fastly/faff97a89735556906d9b2e20e0503a85125114885fd4166343daa213591b872.jpeg",
    "https://cdn.faire.com/fastly/d2cf762ab8f161ee3a54712c9ebe0443b7bfbacd54b70947aba80ecfa7241169.jpeg",
    "https://cdn.faire.com/fastly/5d51076e7d93958438b121568d638c45c2523d768433a05a59d8f074ff1721d6.jpeg",
  ],
  priceDollars: 15,
  description:
    'Our Classic Brown moccasin is our best seller for good reason! Stylish and versatile, your little one can dress up or dress down with the original baby moccasin.\n\nSizing: \nUS 2 (0-6 Months, 3.75" Sole).\nUS 3 (3-6 Months; 4.125" Sole)\nUS 4 (6-12 Months, 4.5" Sole).\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:43.800Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
